// extracted by mini-css-extract-plugin
export var typingIndicator = "_sb-0";